class Quickview {
  constructor (triggerButtonList) {
    this.triggerButtonListElems = triggerButtonList || []
    this.modalElem = document.querySelector('#quickview-modal')
    this.closeButtonElem = this.modalElem.querySelector('#quickview-close')
    this.quickviewStructureElem = this.modalElem.querySelector(
      '#quickview-structure'
    )
    this.buildModal = this.buildModal.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.updateQuickview = this.updateQuickview.bind(this)
    this.addToCart = this.addToCart.bind(this)
  }

  init () {
    this.addClickEvents()
    this.buildWishlistButtons()
  }

  addButtonToOpen($button) {
    const { productHandle } = $button.dataset
    const productHandleParsed = productHandle.replace(/-\d+$/, '')
    this.buildWishlistButton(productHandleParsed, $button)
    $button.addEventListener('click', this.buildModal)
  }

  buildWishlistButtons () {
    this.triggerButtonListElems.forEach(button => {
      const { productHandle } = button.dataset
      const productHandleParsed = productHandle.replace(/-\d+$/, '')
      this.buildWishlistButton(productHandleParsed, button)
    })
  }

  async buildWishlistButton (productHandle, button) {
    const productData = await this.getProductData(productHandle)
    const $product = $(button).closest('.product-card')
    
    const variantIdsAndFeaturedImage = productData.variants.map(variant => ({
      id: variant.id,
      featuredImage: variant.featured_image?.src ? variant.featured_image.src : productData.featured_image.src,
      price: variant.price / 100
    }))
    
    variantIdsAndFeaturedImage.forEach((variant, index) => {
      const uniqueClassName = `wishlist-button-${variant.id}`
      const isActive = index === 0
      const activeClassName = isActive ? ' active' : ''
      const featuredImageName = variant.featuredImage ? this.getImageName(variant.featuredImage) : ''
      
      const containerHTML = `
        <div class="gm-custom-wishlist-button ${uniqueClassName}${activeClassName}" 
             data-variant-id="${variant.id}" 
             data-featured-image="${featuredImageName}">
          <button class="gm-custom-wishlist-button ${uniqueClassName}"></button>
        </div>
      `
      
      $product[0].insertAdjacentHTML('beforeend', containerHTML.trim())

      setTimeout(() => {
        WishListHero_SDK.InitializeAddToWishListButton({
          ProductId: productData.id, // ID del producto
          ProductVariantId: variant.id, // ID de la variante específica
          ProductTitle: productData.title, // Título del producto para mostrar en la wishlist
          ProductPrice: variant.price, // Precio de la variante
          ProductLink: `${productData.url}?variant=${variant.id}`, // URL directa a esta variante
          ProductImage: variant.featuredImage, // Imagen que se mostrará en la wishlist
          ButtonClassElement: uniqueClassName, // Clase única para que el SDK identifique este botón
          ButtonMode: 'icon_only', // Modo de visualización: solo icono, sin texto
          WishlistHash: WishListHero_SDK.GetWishListHash() === null ? 'WpE2nGb6n2fx5JxJoO3l' : WishListHero_SDK.GetWishListHash() // Hash de la wishlist del usuario actual
          // WishlistHash: WishListHero_SDK.GetWishListHash() // Hash de la wishlist del usuario actual
        });
      }, 2000)

    })

    if (productData.variants.length > 1) {
      this.addEventsForVariantSwatches($product[0])
    }
  }

  addEventsForVariantSwatches($productCard) {
    const variantSwatches = $productCard.querySelectorAll('.grid-view-item__variant')
    if (variantSwatches.length === 0) {return;}
    const events = ['click', 'mouseover']
    variantSwatches.forEach(swatch => {
      events.forEach(eventName => {
        swatch.addEventListener(eventName, (event) => this.showSelectedVariantWishlistButton($productCard, event.target))
      })
    })
  }

  showSelectedVariantWishlistButton($productCard, $variantSwatch) {
    // Con base en la url de la variante seleccionada, se seleccionará el botón de la wishlist correspondiente
    const $image = $variantSwatch.tagName === 'IMG' ? $variantSwatch : $variantSwatch.querySelector('.grid-view-item__variant-image')
    const originalSrc = $image.src
    let src = this.getImageName(originalSrc)
    // si src contiene un _, hacer split y tomar el primer elemento
    if (src.includes('_340x')) {
      src = src.split('_340x')[0]
    }
    // buscar en el DOM el elemento con la clase gm-custom-wishlist-button y la clase uniqueClassName
    const $wishlistButton = $productCard.querySelector(`.gm-custom-wishlist-button[data-featured-image^="${src}"]`)
    // si $wishlistButton es null, no hacer nada
    if ($wishlistButton !== null) {
      // quitar la clase active de todos los botones
      $productCard.querySelectorAll('.gm-custom-wishlist-button').forEach(button => {
        button.classList.remove('active')
      })
      // agregar la clase active al botón seleccionado
      $wishlistButton.classList.add('active')
    }
  }

  addClickEvents () {
    this.triggerButtonListElems.forEach(button => {
      button.addEventListener('click', this.buildModal)
    })

    this.closeButtonElem.addEventListener('click', this.closeModal)
  }

  activeAddToCartEvents () {
    const addToCartButton = this.modalElem.querySelector(
      '#quickview-add-to-cart'
    )

    if (addToCartButton !== null) {
      addToCartButton.addEventListener('click', this.addToCart)
    }
  }

  showError (message) {
    const errorElem = this.modalElem.querySelector('#quickview-error')

    if (errorElem !== null) {
      errorElem.innerHTML = `<span>${message}</span>`
      errorElem.classList.add('active')

      const disappear = setTimeout(() => {
        errorElem.classList.remove('active')
        clearTimeout(disappear)
      }, 4000)
    }
  }

  async addToCart () {
    const variantElemSelected =
            this.modalElem.querySelector('.variant--selected') ||
            this.modalElem.querySelector('#quickview-variant-list')
    const variantQuantity =
            this.modalElem.querySelector('#quantity-input').value
    const { variantId, variantPrice, variantCompareAtPrice } =
            variantElemSelected.dataset

    const variantData = {
      items: [
        {
          id: variantId,
          quantity: variantQuantity
        }
      ]
    }

    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(variantData)
    }

    try {
      const response = await fetch('/cart/add.js', options)

      if (response.status == 200) {
        this.closeModal()
        const cartData = await response.json()
        const variantData = {
          ...cartData.items[0],
          variantPrice,
          variantCompareAtPrice
        }

        const responseCurrentCart = await fetch('/cart.js')

        if (responseCurrentCart.status == 200) {
          const currentCartData = await responseCurrentCart.json()
          variantData.totalPrice = currentCartData.total_price
        }

        // this.showCartNotification(variantData)
      } else {
        const cartError = await response.json()
        console.log(cartError)

        cartError.status === 404 || cartError.status === 422
          ? this.showError(cartError.description)
          : this.showError('Stock insuficiente.')
      }
    } catch (error) {
      console.error(`Error: ${error}`)
      this.showError(`Ocurrió un error: ${error}`)
    }
  }

  showCartNotification (variant) {
    const notificationElem = document.querySelector('#notification')

    if (notificationElem !== null) {
      const splitTitle = title => [
        title.replace(/^\w+\.\d+\s/, ''),
        title.match(/^\w+\.\d+/)
      ]

      const imageElem = notificationElem.querySelector('#notif-prod-image')
      const titleElem = notificationElem.querySelector('#notif-prod-title')
      const skuElem = notificationElem.querySelector('#notif-prod-art-number')
      const variantOptionElem =
                notificationElem.querySelector('#notif-prod-variant')
      const quantityElem = notificationElem.querySelector('#notif-prod-qty')
      const priceWrapperElem =
                notificationElem.querySelector('#notif-prod-price')
      const priceChildElem = notificationElem.querySelector('[data-price]')
      const subTotalElem = notificationElem.querySelector('#notif-subtotal')

      const [title, sku] = splitTitle(variant.product_title)
      const variantOption = `${variant.options_with_values[0].name}: ${variant.options_with_values[0].value}`
      const quantity = variant.quantity
      const totalPrice = formatMoney(variant.totalPrice, '${{amount}}')
      let price = variant.variantPrice
      let compareAtPrice = variant.variantCompareAtPrice
      const compareAtPriceExist = compareAtPrice !== 'null'
      const discount = Math.round(100 - (price / compareAtPrice) * 100)
      price = formatMoney(price, '${{amount}}')
      compareAtPrice = formatMoney(compareAtPrice, '${{amount}}')

      const fullPriceElem = `
                <div class="price__regular">
                    <dt>
                        <span class="visually-hidden visually-hidden--inline">Precio habitual</span>
                    </dt>
                    <dd>
                        <span class="price-item price-item--regular" data-regular-price="">
                            ${compareAtPriceExist ? compareAtPrice : price}
                        </span>
                    </dd>
                </div>
            `

      const promoPriceElem = compareAtPriceExist
        ? `<div class="price__sale">
                    <dt>
                        <span class="visually-hidden visually-hidden--inline">${price}</span>
                    </dt>
                    <dd>
                        <span class="price-item price-item--sale" data-sale-price="${price}">
                            ${price}
                        </span>
                        <span class="price-item__label" aria-hidden="true">Oferta</span>
                    </dd>
                </div>`
        : ''

      const discountElem = compareAtPriceExist
        ? `
                 <div class="price price--on-sale">
                    <span class="price-item price-item--sale" data-sale-price="">${discount}% de descuento </span>
                </div>
            `
        : ''

      const priceComponent = `
                <dl class="price ${
                    compareAtPriceExist ? 'price--on-sale' : ''
                }" data-price="">
                    ${fullPriceElem}
                    ${promoPriceElem}
                    ${discountElem}
                </dl>`

      imageElem.src = variant.featured_image.url
      titleElem.textContent = title
      skuElem.textContent = sku
      variantOptionElem.textContent = variantOption
      quantityElem.textContent = quantity
      priceChildElem !== null
        ? (priceChildElem.innerHTML = priceComponent)
        : (priceWrapperElem.innerHTML += priceComponent)
      subTotalElem.textContent = totalPrice

      notificationElem.classList.add('visible', 'showme')

      const hide = setTimeout(() => {
        notificationElem.classList.remove('showme')

        const disappear = setTimeout(() => {
          notificationElem.classList.remove('visible')

          clearTimeout(disappear)
        }, 500)

        clearTimeout(hide)
      }, 4000)
    }
  }

  activeVariantEvents () {
    const variantListElem = this.modalElem.querySelectorAll(
      '.quickview__variant-item'
    )

    if (variantListElem.length > 0) {
      variantListElem.forEach(variantElem => {
        variantElem.addEventListener('click', this.updateQuickview)
      })
    }
  }

  activeQuantityEvents () {
    const $quantityDetails = this.modalElem.querySelector('[data-quantity]')
    const $quantityInput = this.modalElem.querySelector('[data-quantity-input]')
    const $quantityItems = this.modalElem.querySelectorAll('[data-quantity-item]')
    if ($quantityDetails.length === 0) {return;}

    document.addEventListener('click', (event) => {
      if (!event.target.closest('[data-quantity]') && $quantityDetails.open) {
        $quantityDetails.open = false
      }
    })

    $quantityInput.addEventListener('input', (event) => {
      $quantityInput.value = event.target.value
    })

    $quantityInput.addEventListener('blur', () => {
      if ($quantityInput.value === "" || Number($quantityInput.value) === 0) {
        $quantityInput.value = 1
        $quantityInput.tabIndex = -1
      }

      if (Number($quantityInput.value) <= 9) {
        $quantityInput.tabIndex = -1
      }
    })

    $quantityItems.forEach($quantityListItem => {
      $quantityListItem.addEventListener('click', () => {
        $quantityDetails.open = false

        if ($quantityListItem.dataset.value === '10+') {
          $quantityInput.tabIndex = 0
          $quantityInput.value = ""
          $quantityInput.focus()
        } else {
          $quantityInput.tabIndex = -1
          $quantityInput.value = Number($quantityListItem.dataset.value)
        }
      })
    })
  }

  updateQuickview (event) {
    event.preventDefault()
    const variantElemOldSelected =
            this.modalElem.querySelector('.variant--selected')
    const variantElemSelected = event.target.closest('.quickview__variant-item')
    const {
      variantId,
      variantImageSrc,
      variantImageAlt,
      variantPrice,
      variantCompareAtPrice,
      variantTitle
    } = variantElemSelected.dataset

    variantElemOldSelected.classList.remove('variant--selected')
    variantElemSelected.classList.add('variant--selected')

    this.updateImageComponent(variantImageSrc, variantImageAlt)
    this.updatePriceComponent(variantPrice, variantCompareAtPrice)
    this.updateDetailsComponent(variantTitle)
  }

  updateDetailsComponent (title) {
    const quickviewVariantValue = this.modalElem.querySelector(
      '#quickview-variant-value'
    )

    if (title !== null || title !== undefined) {
      quickviewVariantValue.textContent = title
    }
  }

  updatePriceComponent (price, compareAtPrice) {
    const compareAtPriceExist = compareAtPrice !== 'null'
    const discount = Math.round(100 - (price / compareAtPrice) * 100)
    const priceMoney = formatMoney(price, '${{amount}}')
    const compareAtPriceMoney = formatMoney(compareAtPrice, '${{amount}}')
    const priceElem = this.modalElem.querySelector('#quickview-price')
    const compareAtPriceElem = this.modalElem.querySelector(
      '#quickview-compare-at-price'
    )
    const discountElem = this.modalElem.querySelector('#quickview-discount')

    if (compareAtPriceExist) {
      priceElem.textContent = compareAtPriceMoney
      compareAtPriceElem.textContent = priceMoney
      discountElem.textContent = `${discount}% de descuento`
    } else {
      priceElem.textContent = priceMoney
    }
  }

  updateImageComponent (imageSrc, imageAlt) {
    const imageElem = this.modalElem.querySelector('#quickview-img')

    if (imageElem !== null) {
      imageElem.src = imageSrc
      imageElem.alt = imageAlt
    }
  }

  async buildModal (event) {
    event.preventDefault()
    const quickviewButton =
            event.target.localName === 'button'
              ? event.target
              : event.target.closest('button')

    const { productHandle } = quickviewButton.dataset
    const productHandleParsed = productHandle.replace(/-\d+$/, '')
    const productData = await this.getProductData(productHandleParsed)
    const selectedVariant = this.getSelectedVariant(quickviewButton, productData)
    this.quickviewStructureElem.innerHTML = `
                ${this.buildImageComponent(quickviewButton, productData)}

                <div class="quickview__details">
                    ${this.buildInfoComponent(productData, selectedVariant)}
                    ${this.buildMessageComponent(productData)}
                    ${this.buildVariantsComponent(productData, selectedVariant)}
                    ${this.buildOptionsComponent(productData, selectedVariant)}
                </div>
            `
    this.activeVariantEvents()
    this.activeQuantityEvents()
    this.activeAddToCartEvents()
    this.showModal()
  }

  getSelectedVariant(handleElem, productData) {
    const selectedImage = handleElem.closest('.product-card').querySelector('.grid-view-item__image')
    const productImageName = this.getImageName(selectedImage.src)
    const selectedVariant = productData.variants.find(variant => {
      const variantImageName = variant.featured_image ? this.getImageName(variant.featured_image.src) : ""
      return variantImageName && productImageName.includes(variantImageName)
    })
    return selectedVariant
  }

  buildQuickViewButton(data) {
    if (data.metafields.purchase_only_in_store) {
      return `<div class="quickview__button btn button--add-to-cart" id="quickview-add-to-cart" disabled>Producto a la venta solo en tienda física</div>`;
    }
    return `<button class="quickview__button btn button--add-to-cart" id="quickview-add-to-cart">Agregar a carrito</button>`;
  }

  buildOptionsComponent (data, selectedVariant) {
    return `
            <footer class="quickview__options">
                <div class="quickview__quantity-wrapper section-block">
                    <span class="quickview__quantity-label">Cantidad:</span>

                    <details class="quickview__quantity-details" data-quantity>
                      <summary class="quickview__quantity-summary">
                        <input type="number" class="quickview__quantity-input" id="quantity-input" min="1" value="1" data-quantity-input tabindex="-1">
                        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none"> <path fill-rule="evenodd" clip-rule="evenodd" d="M5.46095 8.58883L0.21551 3.69427C-0.0718367 3.40952 -0.0718366 2.97343 0.21551 2.70531C0.502856 2.43718 0.970219 2.43718 1.27537 2.70531L6 7.11389L10.7246 2.70531C11.012 2.43718 11.4971 2.43718 11.7845 2.70531C12.0718 2.97343 12.0718 3.40953 11.7845 3.69427L6.52081 8.58883C6.23346 8.85696 5.7661 8.85696 5.46095 8.58883Z" fill="#2D2D2D"/> </svg>
                      </summary>
                      <ul class="quickview__quantity-items">
                        <li class="quickview__quantity-item" data-value="1" data-quantity-item>1</li>
                        <li class="quickview__quantity-item" data-value="2" data-quantity-item>2</li>
                        <li class="quickview__quantity-item" data-value="3" data-quantity-item>3</li>
                        <li class="quickview__quantity-item" data-value="4" data-quantity-item>4</li>
                        <li class="quickview__quantity-item" data-value="5" data-quantity-item>5</li>
                        <li class="quickview__quantity-item" data-value="6" data-quantity-item>6</li>
                        <li class="quickview__quantity-item" data-value="7" data-quantity-item>7</li>
                        <li class="quickview__quantity-item" data-value="8" data-quantity-item>8</li>
                        <li class="quickview__quantity-item" data-value="9" data-quantity-item>9</li>
                        <li class="quickview__quantity-item" data-value="10+" data-quantity-item>10+</li>
                      </ul>
                    </details>
                </div>
            </footer>

            <div class="quickview__cart">
                ${this.buildQuickViewButton(data)}
                <div class="quickview__error" id="quickview-error"></div>
                <a href="/products/${data.handle}?variant=${selectedVariant.id}" class="quickview__product-details">Ver detalles del producto</a>
            </div>
        `
  }

  buildVariantsComponent (data, selectedVariant) {
    const getFirstVariantAvailable = variantList =>
      variantList.find(variant => (variant.available ? variant : null))

    const firstVariantAvailable = getFirstVariantAvailable(data.variants)

    const buildDetails = optionList => {
      return optionList
        .map(option => {
          return `
                    <div class="quickview__variant-details">
                        <strong class="quickview__variant-option">${option.name}:</strong>
                        <span class="quickview__variant-value" id="quickview-variant-value">${selectedVariant.title}</span>
                    </div>
                `
        })
        .join('')
    }

    const buildVariantsList = (optionList, variantList) => {
      const allOptions = []

      optionList.forEach(option => {
        allOptions.push(...option.values)
      })

      return variantList
        .reduce((availableVariants, variant) => {
          if (variant.available) {
            const selectedVariantImageName = selectedVariant.featured_image ? this.getImageName(selectedVariant.featured_image.src) : ""
            const variantImageName = variant.featured_image ? this.getImageName(variant.featured_image.src) : ""
            const classVariantSelected =
                            selectedVariantImageName && variantImageName && selectedVariantImageName.includes(variantImageName) 
                              ? 'variant--selected'
                              : ''

            const variantElem = `
                        <li class="quickview__variant-item ${classVariantSelected}"
                            aria-label="${variant.title}"
                            data-balloon-pos="down"
                            data-variant-id="${variant.id}"
                            data-variant-image-src="${variant.featured_image ? variant.featured_image.src : ""}"
                            data-variant-image-alt="${variant.featured_image ? variant.featured_image.alt : ""}"
                            data-variant-price="${variant.price}"
                            data-variant-compare-at-price="${variant.compare_at_price}"
                            data-variant-title="${variant.title}"
                                />
                            <img src="${variant.featured_image ? variant.featured_image.src : ""}"
                                alt="${variant.featured_image ? variant.featured_image.alt : ""}"
                                class="quickview__variant-image">
                        </li>
                    `

            availableVariants.push(variantElem)
          }

          return availableVariants
        }, [])
        .join('')
    }

    return `
            <section class="quickview__variants-wrapper section-block">
                ${
                    firstVariantAvailable !== undefined
                        ? buildDetails(data.options)
                        : ''
                }

                <ul class="quickview__variant-list" id="quickview-variant-list" data-variant-id="${
                    data.id
                }">
                    ${buildVariantsList(data.options, data.variants)}
                </ul>
            </section
        `
  }

  buildMessageComponent (data) {
    const tagsList = data.tags
    const messageList = theme.strings
    const messageListElem = []

    tagsList.forEach(tag => {
      const tagFormatted = tag.toLowerCase()

      if (messageList.hasOwnProperty(tagFormatted)) {
        messageListElem.push(
                    `
                        <section class="quickview__message section-block">
                            <p class="quickview__text">${messageList[tagFormatted]}</p>
                        </section>
                    `
        )
      }
    })

    return messageListElem.join('')
  }

  buildInfoComponent (data, selectedVariant) {
    const splitTitle = title => [
      title.replace(/^\w+\.\d+\s/, ''),
      title.match(/^\w+\.\d+/)
    ]

    const [title, sku] = splitTitle(data.title)
    let price = selectedVariant.price
    let compareAtPrice = selectedVariant.compare_at_price
    const compareAtPriceExist = compareAtPrice !== null
    const discount = Math.round(100 - (price / compareAtPrice) * 100)
    price = formatMoney(price, '${{amount}}')
    compareAtPrice = formatMoney(compareAtPrice, '${{amount}}')

    const fullPriceElem = `
            <span class="quickview__price ${
                compareAtPriceExist ? 'price--promo' : ''
            }" id="quickview-price">${
            compareAtPriceExist ? compareAtPrice : price
        }</span>`

    const promoPriceElem = compareAtPriceExist
      ? `<span class="quickview__compare_at_price" id="quickview-compare-at-price">${price}</span>`
      : ''

    const discountElem = compareAtPriceExist
      ? `<span class="quickview__discount" id="quickview-discount">${discount}% de descuento</span>`
      : ''

    return `
            <header class="quickview__product-info section-block">
                <h2 class="quickview__name">${title}</h2>
                <span class="quickview__sku">${sku}</span>

                <div class="quickview__price-wrapper">
                    ${fullPriceElem}
                    ${promoPriceElem}
                    ${discountElem}
                </div>
            </header>`
  }

  getImageName(url) {
    // Usar split para dividir la URL por los "/"
    const parts = url.split('/');
    // El último elemento del array es el nombre del archivo con parámetros
    const nameWithParams = parts.pop();
    // Eliminar los parámetros de la consulta si existen
    const nameFile = nameWithParams.split('?')[0];
    // Encontrar la última ocurrencia de un punto
    const lastDot = nameFile.lastIndexOf('.');
    // Si hay un punto, eliminar la extensión
    const name = lastDot !== -1 ? nameFile.substring(0, lastDot) : nameFile;
    return name;
  }

  buildImageComponent (handleElem, data) {
    const productImageElem = handleElem
      .closest('.product-card')
      .querySelector('.grid-view-item__image')
    const productImageName = this.getImageName(productImageElem.src)
    const imageSrcListNames = data.images.map(imageSrc => {
      return this.getImageName(imageSrc)
    })
    const imageSrcIndex = imageSrcListNames.findIndex(imageSrc =>
      productImageName.includes(imageSrc)
    )
    const imageSrc = data.images[imageSrcIndex] || data.featured_image
    const imageAlt = data.title

    return `
            <figure class="quickview__image section-block">
                <img src="${imageSrc}"
                    alt="${imageAlt}"
                    class="quickview__img"
                    id="quickview-img"
                    loading="lazy" />
            </figure>
            `
  }

  async getProductData (handle) {
    try {
      const request = await fetch(`/products/${handle}.js`);

      if (request.status !== 200) {
        this.showError('Error en la solicitud');
        return null;
      }

      const productData = await request.json();
      const requestMetafields = await fetch(`/products/${handle}?view=metafields`);

      if (requestMetafields.status == 200) {
        const metafieldData = await requestMetafields.json();
        productData.metafields = metafieldData;
      }

      return productData;
        
    } catch (error) {
      console.error(`Error: ${error}`)
      this.showError(`Ocurrió un error: ${error}`)
    }
  }

  showModal () {
    this.modalElem.classList.add('active')
  }

  closeModal () {
    this.modalElem.classList.remove('active')
  }
}

const quickview = new Quickview()
quickview.init()

// Aditional
function createElementObserver({
  target = document.body,
  selectors = {},
  oncePerElement = true,
}) {
  if (!target) {
    throw new Error('Target requerido');
  }

  if (typeof selectors !== 'object') {
    throw new Error('selectors debe ser un objeto');
  }

  const processed = new WeakSet();
  const selectorEntries = Object.entries(selectors);

  const executeCallback = (element, callback) => {
    if (oncePerElement && processed.has(element)) return;

    processed.add(element);

    callback(element);
  };

  const processNode = (node) => {
    if (!(node instanceof HTMLElement)) return;

    for (const [selector, callback] of selectorEntries) {
      if (typeof callback !== 'function') continue;

      // match directo
      if (node.matches(selector)) {
        executeCallback(node, callback);
      }

      // matches hijos
      const matches = node.querySelectorAll(selector);

      matches.forEach((element) => {
        executeCallback(element, callback);
      });
    }
  };

  // contenido inicial
  processNode(target);

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach(processNode);
    }
  });

  observer.observe(target, {
    childList: true,
    subtree: true,
  });

  return {
    disconnect() {
      observer.disconnect();
    },

    reconnect() {
      observer.observe(target, {
        childList: true,
        subtree: true,
      });
    },
  };
}

// Configs Product Cards
const configButtonATC = async ($element) => {
  const $oldButton = $element.querySelector('.ss-quickview-item-button.js-preview-btn-bpfs')
  if (!$oldButton) return
  $oldButton.textContent = 'Agregar a carrito'
  $oldButton.style.pointerEvents = 'none'
  $oldButton.classList.remove('blue', "uppercase")
  const $newButton = $oldButton.cloneNode(true)
  const productHandle = $oldButton.dataset.handle
  const productHandleParsed = productHandle.replace(/-\d+$/, '')
  const productData = await quickview.getProductData(productHandleParsed)
  const variants = productData.variants
  const availableVariants = variants.filter(variant => variant.available)

  if (availableVariants.length > 1) {
    $newButton.dataset.productHandle = productHandle
    quickview.addButtonToOpen($newButton)
  } else {
    quickview.buildWishlistButton(productHandleParsed, $newButton)
    $newButton.addEventListener('click', () => {
      $newButton.disabled = true
      window.fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [
            { id: variants[0].id, quantity: 1 }
          ]
        })
      })
      .then(() => {
        $newButton.disabled = false
      })
    })
  }

  $newButton.style.pointerEvents = 'auto'
  $oldButton.parentNode.replaceChild($newButton, $oldButton)
}

const configVariantsActive = ($element) => {
  const $variants = $element.querySelectorAll('.grid-view-item__variant')
  if ($variants.length === 0) return

  $variants[0].classList.add('active')

  $variants.forEach(($variant) => {
    $variant.addEventListener('mouseenter', () => {
      $variants.forEach(($variant) => $variant.classList.remove('active'))
      $variant.classList.add('active')
    })
  })
}

const configHequalizer = ($element) => {
  const $variantsWrapper = $element.querySelector('.grid-view-item__image-wrapper ~ .grid-view-item__variants')
  if ($variantsWrapper === null) {
    const $newVariantsWrapper = document.createElement('div');
    $newVariantsWrapper.className = 'grid-view-item__variants';
    $element.insertBefore($newVariantsWrapper, $element.querySelector('.grid-view-item__image-wrapper').nextSibling);
  }

  if (window.HequalizerAPI.Instances.length > 0) {
    window.HequalizerAPI.Instances.forEach(instance => instance.destroy(true))
  }

  const options = {
    columns: 4,
    responsive: {
      1200: {
        columns: 3
      },
      840: {
        columns: 2
      }
    },
  }

  new window.HequalizerAPI.Init($element.parentNode.querySelectorAll('.grid-view-item__variants'), options)
  new window.HequalizerAPI.Init($element.parentNode.querySelectorAll('.grid-view-item__title'), options)
  new window.HequalizerAPI.Init($element.parentNode.querySelectorAll('.grid-view-item__price'), options)
}

const observer = createElementObserver({
  target: document.querySelector('.main-collection-products'),
  selectors: {
    '.main-collection-products .product-card': ($element) => {
      configVariantsActive($element)
      configButtonATC($element)
      configHequalizer($element)
    },
  },
});
